import { db } from '../../../firebase'
import { collection, getDocs, orderBy, query } from 'firebase/firestore'
import { normalizeTx } from './goldTxRecords.mjs'
export * from './goldTxRecords.mjs'

export async function fetchGoldTransactions() {
  const snap = await getDocs(query(collection(db, 'gold_transactions'), orderBy('createdAt', 'desc')))
  return snap.docs.map((d) => normalizeTx(d.id, d.data()))
}
